<div class="flex jcc"><span [innerHTML]="payload.properties.value.value | tokenToDiv"></span></div>
